<template>
    <div class="Pagination">
      <div class="paginationLink prev" role="link" tabindex="0" @click="prevProject">
        <span>Prev</span>
        <span>{{ prevLabel }}</span>
      </div>
      <div class="paginationLink next" role="link" tabindex="0" @click="nextProject">
        <span>Next</span>
        <span>{{ nextLabel }}</span>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    prevLabel: {
      type: String,
      default: null
    },
    nextLabel: {
      type: String,
      default: null
    },
    prevRoute: {
      type: String,
      default: null
    },
    nextRoute: {
      type: String,
      default: null
    }
  },
  data() {
    return {
    }
  },
  methods: {
    prevProject() {
      this.$router.push({ name: this.prevRoute })
    },
    nextProject() {
      this.$router.push({ name: this.nextRoute })
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.Pagination {
  @include siteWrapper;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px auto;

  & .paginationLink {
    transition: all 300ms;
    position: relative;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 1%;
      height: 1px;
      background: #fff;
      transition: all 200ms;
    }

    &.active, &:hover {
      color: #000;

      &::after {
        width: 100%;
        background: #000;
      }
    }

    & span {
      display: block;
      line-height: 22px;
    }

    & span:first-child {
      @include fontHeadItalic;
      font-size: 13px;
    }
    & span:last-child {
      text-transform: uppercase;
      font-size: 15px;
      @include fontBodyHead;
    }
    &.next {
      text-align: right;
    }
    &:focus {
      outline: none;
    }
  }
  @media screen and (max-width: $breakSmall) {
    justify-content: center;
    margin: 30px auto;

    & .paginationLink {
      width: 45%;

      &.active, &:hover {

        &::after {
          width: 1%;
          background: #fff;
        }
      }
      &.prev {
        text-align: right;
        padding: 0 15px 0 0;
      }
      &.next {
        text-align: left;
        padding: 0 0 0 15px;
        border-left: 1px solid #000;
      }
    }
  }
}
</style>
